<script>
import BaseStatusTile from '@/components/base/BaseStatusTile.vue';
import BaseStatusEditor from '@/components/base/BaseStatusEditor.vue';
import api from '@/api/taskStatus';

export default {
  name: 'TaskStatus',
  components: { BaseStatusTile, BaseStatusEditor },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: String,
    changeable: Boolean,
    editable: Boolean,
    gray: Boolean,
    project: Object,
  },
  computed: {
    items() { return this.project?.taskStatuses ?? []; },
    usedColors() { return this.items.map(s => s.color); },
  },
  methods: {
    async create({ data }) {
      const project = this.project['@id'];
      const result = await api.create({ ...data, project }, true);
      this.$emit('edited', [...this.items, result]);
    },
    async update({ id, data }) {
      const result = await api.update(id, data, true);
      const items = [...this.items];
      const index = items.findIndex(item => item.id === id);
      items[index] = result;
      this.$emit('edited', items);
    },
    async remove({ id }) {
      await api.delete(id, true);
      const items = this.items.filter(item => item.id !== id);
      this.$emit('edited', items);
    },
  },
};
</script>

<template lang="pug">
  BaseStatusEditor(
    v-slot="{ onCreate, onUpdate, onRemove }"
    @create="create"
    @update="update"
    @remove="remove"
    :usedColors="usedColors"
  )
    BaseStatusTile(
      :value="value"
      :items="items"
      :changeable="changeable"
      :editable="editable"
      :gray="gray"
      @change="$emit('change', $event)"
      @create="onCreate"
      @update="onUpdate"
      @remove="onRemove"
    )
</template>
